// Contagens de Resumos e Flashcards de um usuário (só números) para as conquistas.
import { useState, useEffect } from "react";
import { sb } from "./supabase";

export async function fetchNoteCounts(uid) {
  try {
    const { data, error } = await sb.rpc("get_notes_cards_counts", { p_user: uid });
    if (error) { console.error("get_notes_cards_counts falhou:", error); return null; }
    const r = Array.isArray(data) ? data[0] : data;
    return r ? { notes: Number(r.notes) || 0, cards: Number(r.cards) || 0, reviewed: Number(r.reviewed) || 0 } : null;
  } catch (e) { console.error("get_notes_cards_counts exceção:", e); return null; }
}

// undefined = carregando · null = indisponível · objeto = contagens
export function useNoteCounts(uid) {
  const [nc, setNc] = useState(undefined);
  useEffect(() => {
    if (!uid) { setNc(null); return; }
    let a = true;
    fetchNoteCounts(uid).then(x => { if (a) setNc(x); });
    return () => { a = false; };
  }, [uid]);
  return nc;
}
